const defaultSizes = {
  sm: "20px",
  md: "24px",
  lg: "28px",
  xl: "32px",
};


export default defaultSizes;